module.exports = __webpack_public_path__ + "img/data_img.6a259cc6.png";